<section>
  <app-toast />

  <div class="flex items-center justify-center text-light-black">
    <router-outlet #outlet="outlet"></router-outlet>
  </div>
</section>
